<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-cookie-consent-shell />
</ion-app>
